import { render, staticRenderFns } from "./FrozenShipments.vue?vue&type=template&id=73e25fef&scoped=true"
import script from "./FrozenShipments.vue?vue&type=script&lang=js"
export * from "./FrozenShipments.vue?vue&type=script&lang=js"
import style0 from "./FrozenShipments.vue?vue&type=style&index=0&id=73e25fef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e25fef",
  null
  
)

export default component.exports